import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { OrganizationWithWorkspaces } from '@/types/Organization';

export interface OrganizationActions {
  setOrganizations: (organizations: Record<string, OrganizationWithWorkspaces>) => void;
  setSelectedOrganization: (organizationId: OrganizationWithWorkspaces | null) => void;
  resetSelectedOrganization: () => void;
  reset: () => void;
}

export interface OrganizationStoreState {
  selectedOrganization: OrganizationWithWorkspaces | null;
  organizations: Record<string, OrganizationWithWorkspaces>;
}

const initialState: OrganizationStoreState = {
  selectedOrganization: null,
  organizations: {},
};

export const useOrganizationStore = create<
  OrganizationStoreState & OrganizationActions
>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        setOrganizations(organizations: Record<string, OrganizationWithWorkspaces>) {
          set((state) => ({ ...state, organizations }));
        },
        setSelectedOrganization(organization: OrganizationWithWorkspaces | null) {
          set((state) => ({ ...state, selectedOrganization: organization }));
        },
        resetSelectedOrganization() {
          set((state) => ({ ...state, selectedOrganization: null }));
        },
        reset() {
          set(initialState);
        },
      }),
      {
        name: 'organization-storage',
      },
    ),
    { name: 'organization-store' },
  ),
);
